import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const seloExplosivo: TechniqueDefinition = {
  id: "selo_explosivo",
  name: "Selo Explosivo",
  description:
    "Detonates a chakra seal in an area as part of the same action. It does not require another seal to be placed first.",
  family: "fuinjutsu",
  proficiency: "ninjutsu",
  targeting: "circle",
  behavior: { kind: "damage" },
  levels: {
    1: {
      chakraCost: 24,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 10,
      attackCoefficient: 0.95,
      radius: 64,
      minimumTargets: 1,
    },
    2: {
      chakraCost: 24,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 11,
      attackCoefficient: 0.99,
      radius: 66,
      minimumTargets: 1,
    },
    3: {
      chakraCost: 25,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 12,
      attackCoefficient: 1.03,
      radius: 68,
      minimumTargets: 1,
    },
    4: {
      chakraCost: 26,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 13,
      attackCoefficient: 1.07,
      radius: 70,
      minimumTargets: 1,
    },
    5: {
      chakraCost: 27,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 14,
      attackCoefficient: 1.11,
      radius: 72,
      minimumTargets: 1,
    },
    6: {
      chakraCost: 28,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 15,
      attackCoefficient: 1.15,
      radius: 74,
      minimumTargets: 1,
    },
    7: {
      chakraCost: 29,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 16,
      attackCoefficient: 1.19,
      radius: 76,
      minimumTargets: 1,
    },
    8: {
      chakraCost: 30,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 17,
      attackCoefficient: 1.23,
      radius: 78,
      minimumTargets: 1,
    },
    9: {
      chakraCost: 31,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 18,
      attackCoefficient: 1.27,
      radius: 80,
      minimumTargets: 1,
    },
    10: {
      chakraCost: 32,
      cooldownMs: 8_000,
      range: 220,
      maxTargets: 4,
      power: 18,
      attackCoefficient: 1.3,
      radius: 82,
      minimumTargets: 1,
    },
  },
  visual: {
    effectId: 225,
    castEffectId: null,
    missileId: 173,
    projectileFlightMs: 350,
    armedEffectId: 458,
    armingDelayMs: 550,
    explosionEffectId: 225,
    impactEffectId: null,
  },
};
